import styles from './TitleBlock.module.scss'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const tweenVars = [
  {
    y: '50',
    duration: 1,
    opacity: 0,
    ease: Power4.easeOut,
  },
]

interface Props {
  sectionTitle: {
    title: string
    sub_title: string
    description?: string
  }
  isColumn?: boolean
}

const TitleBlock: React.FC<Props> = ({ sectionTitle, isColumn }) => {
  const timeline = gsap.timeline()
  const title = useRef<HTMLDivElement>(null)
  const descriptionRef = useRef<HTMLParagraphElement>(null)

  useEffect(() => {
    if (title.current) {
      // タイトルのアニメーション
      Array.prototype.forEach.call(title.current.children, (element: HTMLElement, index: number) => {
        timeline.from(element.childNodes, tweenVars[0], 0.2 * (index + 1))
      })

      // 説明文が存在する場合にアニメーションを適用
      if (descriptionRef.current) {
        timeline.from(descriptionRef.current, tweenVars[0], 0.4)
      }

      ScrollTrigger.create({
        animation: timeline,
        trigger: title.current,
        start: 'top-=250 70%',
        toggleActions: 'play none none reverse',
      })
    }

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
      timeline.kill()
    }
  }, [])

  return (
    <div className={styles.title} ref={title}>
      <h3 className={`${styles.title_head} title_head ${isColumn && styles.title_head_column}`}>
        <span className={styles.title_head_en}>{sectionTitle.title}</span>
        <span className={styles.title_head_ja}>{sectionTitle.sub_title}</span>
      </h3>
      {sectionTitle.description && (
        <p className={`${styles.title_text} title_text`} ref={descriptionRef}>
          {sectionTitle.description}
        </p>
      )}
    </div>
  )
}

export default TitleBlock
